import EmailLabel from '@monorepo/common/component/EmailLabel';
import PersonNameLabel from '@monorepo/common/component/person/PersonNameLabel';
import PhoneLabel from '@monorepo/common/component/PhoneLabel';
import SexLabel from '@monorepo/common/component/SexLabel';
import React, { ReactNode } from 'react';
import { Col, Row } from 'reactstrap';
import { PersonQuery } from '../../graphql-operations';

interface PersonRowProps {
  label: string;
  value?: ReactNode;
  children?: ReactNode;
}

const PersonRow = ({ label, value, children }: PersonRowProps) => {
  return (
    <Row>
      <Col sm={12} md={5}>
        <span className="text-muted">{label}</span>
      </Col>
      <Col sm={12} md={7}>
        {children || value}
      </Col>
    </Row>
  );
};

interface PersonDetailViewProps {
  person: NonNullable<PersonQuery['person']>;
}

export default function PersonDetailView({ person }: PersonDetailViewProps) {
  const { personData } = person;
  return (
    <>
      {/*Header with name and New icon*/}
      <Row>
        <Col>
          <h2>
            <PersonNameLabel person={person} />
          </h2>
        </Col>
      </Row>

      {/*Person info*/}
      <Row>
        <Col sm={6}>
          <PersonRow label="Telefon">
            <PhoneLabel phoneNumber={personData.phone} />
          </PersonRow>
        </Col>
        <Col sm={6}>
          <PersonRow label="E-mail">
            <EmailLabel email={personData.email} />
          </PersonRow>
          {/*@ts-ignore*/}
          <PersonRow label="Pohlaví">{personData.sex && <SexLabel sex={personData.sex} />}</PersonRow>
        </Col>
      </Row>
    </>
  );
}
